/*----------------------------------------------------------------------------*\
    module.pagination
    Simple pagination object
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};
oy.module = oy.module || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */



/*  Component
\*----------------------------------------------------------------------------*/

oy.module.pagination = {
    name: 'pagination', // name of object for debugging purposes

    init: () => {
        const self = oy.module.pagination;
        // console.log(`${self.name}: init`);
        self.setupContainer();
    },

    setupContainer: ($context) => {
        const self = oy.module.pagination;

        // Always have a working context
        const $workingContext = $context || document.body;

        const $containers = $workingContext.querySelectorAll(`[data-module=${self.name}]`);

        [].forEach.call($containers, ($container) => {
            self.initPagination($container);
        });
    },

    initPagination: ($container) => {
        if (!$container) {
            return false;
        }

        // const self = oy.module.pagination;


        $container.classList.add('is-initialised');
        let itemsAround = 2;
        if ($container.getAttribute('data-pagination-items-around')) {
            itemsAround = parseFloat($container.getAttribute('data-pagination-items-around'));
        }

        var paginationSelector = $container.querySelector('.js--pagination__pane .is-active');

        if (paginationSelector && paginationSelector.parentNode) {
            const $activeItem = paginationSelector.parentNode;
            $activeItem.classList.remove('u-visuallyhidden');
            let $nextItem = $activeItem.nextElementSibling;
            let iNext = 1;
            let showDotsNext = false;
            let $prevItem = $activeItem.previousElementSibling;
            let iPrev = 1;
            let showDotsPrev = false;

            while ($nextItem) {
                $nextItem.classList.remove('u-visuallyhidden');

                if (iNext > itemsAround) {
                    $nextItem.classList.add('u-visuallyhidden');
                    showDotsNext = true;
                }
                if ($nextItem.classList.contains('js--pagination__pane--last')) {
                    break;
                }
                if ($nextItem.classList.contains('js--pagination__dots')) {
                    $nextItem.classList.add('u-visuallyhidden');
                    iNext--;
                }
                $nextItem = $nextItem.nextElementSibling;
                iNext++;
            }

            var $dotsLast = $container.querySelector('.js--pagination__dots--last');

            if (showDotsNext) {
                if ($dotsLast.previousElementSibling.classList.contains('u-visuallyhidden')) {
                    $dotsLast.classList.remove('u-visuallyhidden');
                }
                $container.querySelector('.js--pagination__pane--last').classList.remove('u-visuallyhidden');
            } else {
                $dotsLast.classList.add('u-visuallyhidden');
            }

            while ($prevItem) {
                $prevItem.classList.remove('u-visuallyhidden');

                if (iPrev > itemsAround) {
                    $prevItem.classList.add('u-visuallyhidden');
                    showDotsPrev = true;
                }
                if ($prevItem.classList.contains('js--pagination__pane--first')) {
                    break;
                }
                if ($prevItem.classList.contains('js--pagination__dots')) {
                    $prevItem.classList.add('u-visuallyhidden');
                    iPrev--;
                }
                $prevItem = $prevItem.previousElementSibling;
                iPrev++;
            }

            var $dotsFirst = $container.querySelector('.js--pagination__dots--first');

            if (showDotsPrev) {
                if ($dotsFirst.nextElementSibling.classList.contains('u-visuallyhidden')) {
                    $dotsFirst.classList.remove('u-visuallyhidden');
                }
                $container.querySelector('.js--pagination__pane--first').classList.remove('u-visuallyhidden');
            } else {
                $dotsFirst.classList.add('u-visuallyhidden');
            }
        }

    }

};

